import { render } from "./DeleteAccountModal.vue?vue&type=template&id=5ecab276"
import script from "./DeleteAccountModal.vue?vue&type=script&lang=js"
export * from "./DeleteAccountModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__